import { AnimatedCounter } from "./AnimatedCounter";

export const StatsSection = () => (
  <section className="py-12 bg-red-600 text-white">
    <div className="container-custom">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
        <div className="space-y-2">
          <p className="text-4xl md:text-5xl font-bold">
            <AnimatedCounter end={10} suffix="+" />
          </p>
          <p className="text-blue-100">Années d&apos;expérience</p>
        </div>
        <div className="space-y-2">
          <p className="text-4xl md:text-5xl font-bold">
            <AnimatedCounter end={5000} suffix="+" />
          </p>
          <p className="text-blue-100">Appareils réparés</p>
        </div>
        <div className="space-y-2">
          <p className="text-4xl md:text-5xl font-bold">
            <AnimatedCounter end={212} />
          </p>
          <p className="text-blue-100">Avis Google</p>
        </div>
        <div className="space-y-2">
          <p className="text-4xl md:text-5xl font-bold">
            <AnimatedCounter end={98} suffix="%" />
          </p>
          <p className="text-blue-100">Clients satisfaits</p>
        </div>
      </div>
    </div>
  </section>
);
